/* Zafari (2026-10-16): selector de variantes "moderno" en computadora. El <select> nativo queda (lo escucha
   variant-selects.js de Hyper) pero se oculta, y se dibuja un botón + lista propia (.zf-dd). En celular no se toca:
   el selector nativo de iOS/Android es el que corresponde. Pedido del dueño ("este selector está horrible"). */
(function () {
  'use strict';
  if (!window.matchMedia('(min-width: 768px) and (hover: hover)').matches) return;
  var OFF = /\s*[-–]\s*No disponible\s*$/i;
  var CHEV = '<svg class="zf-dd__chev" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var CHECK = '<svg class="zf-dd__check" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>';

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function enhance(select) {
    if (select.dataset.zfDd) return;
    var wrap = select.closest('.select');
    if (!wrap || wrap.closest('.zf-single')) return;
    select.dataset.zfDd = '1';
    wrap.classList.add('zf-dd');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zf-dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var list = document.createElement('ul');
    list.className = 'zf-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    wrap.appendChild(btn);
    wrap.appendChild(list);

    function build() {
      var cur = select.options[select.selectedIndex];
      var curLabel = cur ? cur.text.replace(OFF, '') : '';
      btn.innerHTML = '<span class="zf-dd__val">' + esc(curLabel) + '</span>' + CHEV;
      var html = '';
      for (var i = 0; i < select.options.length; i++) {
        var o = select.options[i];
        var off = o.disabled || OFF.test(o.text);
        var label = o.text.replace(OFF, '');
        var sel = i === select.selectedIndex;
        html += '<li class="zf-dd__opt' + (sel ? ' is-selected' : '') + (off ? ' is-off' : '') + '" role="option" data-i="' + i + '" aria-selected="' + sel + '">' +
          '<span class="zf-dd__txt">' + esc(label) + '</span>' +
          (off ? '<span class="zf-dd__tag">Sin stock</span>' : (sel ? CHECK : '')) + '</li>';
      }
      list.innerHTML = html;
    }

    function open() { build(); list.hidden = false; btn.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open'); var s = list.querySelector('.is-selected'); if (s) s.scrollIntoView({ block: 'nearest' }); }
    function close() { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open'); }

    btn.addEventListener('click', function () { list.hidden ? open() : close(); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.zf-dd__opt');
      if (!li) return;
      var i = Number(li.dataset.i);
      if (select.selectedIndex !== i) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      close();
      build();
      btn.focus();
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var n = select.selectedIndex + (e.key === 'ArrowDown' ? 1 : -1);
        if (n < 0 || n >= select.options.length) return;
        select.selectedIndex = n;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        build();
      } else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    select.addEventListener('change', build);
    build();
  }

  function scan(root) {
    (root || document).querySelectorAll('variant-selects .product-form__input--dropdown select').forEach(enhance);
  }

  scan();
  // Hyper vuelve a dibujar el selector al cambiar de variante: volvemos a mejorar lo nuevo
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { scan(); break; }
  });
  // se observa la sección entera: Hyper reemplaza el <variant-selects> completo al cambiar de variante
  document.querySelectorAll('variant-selects').forEach(function (vs) { mo.observe(vs.closest('[id^="shopify-section"]') || document.body, { childList: true, subtree: true }); });
})();
